import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import AssignCourseFilter from './pages/assign-course-filter';
import SelectCourse from './pages/select-course';
import css from './index.scss';
import Button from '../button/index';
import messages from './messages';

const AssignCourseConquest = props => (
    <div className={css.assignCourse}>
        <AssignCourseFilter {...props} />
        <SelectCourse {...props} />
        <div className={css.footer}>
            <Button
                containerClassName={css.assignToYear}
                disabled={props.disableAssignToYear}
                handleOnClick={() => props.assignToYearGroup('conquest')}
                label={props.intl.formatMessage(messages.assignToYear)}
            />
        </div>
    </div>
);

AssignCourseConquest.propTypes = {
    intl: intlShape.isRequired,
    assignToYearGroup: PropTypes.func.isRequired,
    disableAssignToYear: PropTypes.bool.isRequired,
    forYear: PropTypes.bool,
    handleOptOutOfCourse: PropTypes.func,
    isUPFSelected: PropTypes.bool
};

export default injectIntl(styleable(css)(AssignCourseConquest));



// WEBPACK FOOTER //
// ./app/components/assign-course-conquest/index.js